var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5881 78.1889C74.0507 78.1889 78.4789 73.7606 78.4789 68.2981C78.4789 62.8355 74.0507 58.4072 68.5881 58.4072C63.1255 58.4072 58.6973 62.8355 58.6973 68.2981C58.6973 73.7606 63.1255 78.1889 68.5881 78.1889Z",
    stroke: "#5D5D5D",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9561 5.56384H38.8815V28.6655C38.9044 30.8492 38.4935 33.0158 37.6725 35.0395C36.8516 37.0632 35.637 38.9037 34.0993 40.4544C32.5615 42.005 30.7311 43.2349 28.7144 44.0726C26.6976 44.9104 24.5345 45.3394 22.3507 45.3347C20.1697 45.3348 18.0104 44.9024 15.9976 44.0626C13.9849 43.2228 12.1586 41.9922 10.6245 40.4421C9.0904 38.8919 7.87892 37.0529 7.06014 35.0315C6.24137 33.01 5.83156 30.8463 5.85442 28.6655V5.56384H15.7453",
    stroke: "#5D5D5D",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3506 45.3347V65.1509C22.3506 68.6547 23.7424 72.0149 26.2199 74.4924C28.6975 76.9699 32.0577 78.3618 35.5614 78.3618C37.2963 78.3618 39.0142 78.0201 40.617 77.3562C42.2198 76.6922 43.6762 75.7191 44.9029 74.4924C46.1296 73.2657 47.1027 71.8093 47.7666 70.2065C48.4305 68.6037 48.7723 66.8858 48.7723 65.1509V45.3347C48.7723 42.7115 49.8143 40.1957 51.6692 38.3408C53.5241 36.4859 56.0399 35.4438 58.6631 35.4438C61.2895 35.4438 63.8088 36.4848 65.6692 38.3387C67.5296 40.1926 68.5793 42.7083 68.5885 45.3347V58.5455",
    stroke: "#5D5D5D",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/stethoscope.8746aa199a911cb60b1f992151795c15.svg";
export { ForwardRef as ReactComponent };